export class BillingActionFilter {
    public IncludeInactive?: boolean;
}

export default BillingActionFilter;